module.exports = __webpack_public_path__ + "static/event_img3@2x-9a9985f4867988ecb53dd1b047a074b4.png";